import type { ZudokuConfig } from "zudoku";

export const redirects: ZudokuConfig["redirects"] = [
	{ from: "/exve", to: "/mobility" },
];

export const protectedRoutes: ZudokuConfig["protectedRoutes"] = ["/settings/*"];
